import { render } from "./openset.vue?vue&type=template&id=25ca4fb6&scoped=true"
import script from "./openset.vue?vue&type=script&lang=js"
export * from "./openset.vue?vue&type=script&lang=js"

import "./openset.vue?vue&type=style&index=0&id=25ca4fb6&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ca4fb6"]])

export default __exports__